import fnv1a from '../../math/prng/fnv1a';

import ServerAssetUploader, { parseAssetDataUrl } from '../../server/ServerAssetUploader';

export default class StubAssetUploader implements ServerAssetUploader {
    async assetExists(_assetId: string): Promise<boolean> {
        return false;
    }

    async uploadAsset(_opts: { assetId: string; body: Buffer; contentType: string }): Promise<void> {
        // no-op
    }

    async uploadDataURLAsset(opts: { dataUrl: string; fileNamePrefix?: string }): Promise<string> {
        const { extension, b64 } = parseAssetDataUrl(opts.dataUrl);

        const hashed = fnv1a(b64);

        return `${opts.fileNamePrefix ?? ''}${hashed}.${extension}`;
    }
}
